import { Card, CardContent, Typography, Link, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { TRUST_COPY } from '../constants/trustCopy';

export interface JoinConfirmationProps {
  /** User's display name (optional, for personalisation) */
  userName?: string;
}

/**
 * JoinConfirmation - Post-join calm confirmation
 *
 * Implements Trust Copy Checklist requirements:
 * - Calm, non-celebratory confirmation
 * - Clear explanation of what happens next
 * - Explicit mention of pause/leave option
 * - No pressure, no gamification
 *
 * Shown immediately after a user joins the programme.
 */
export const JoinConfirmation = ({ userName }: JoinConfirmationProps) => {
  return (
    <Card sx={{ maxWidth: 480, mx: 'auto' }}>
      <CardContent>
        <Typography variant="h2" gutterBottom>
          {TRUST_COPY.JOIN_CONFIRMATION_HEADING}
        </Typography>

        <Typography variant="body1" color="text.secondary" paragraph>
          {TRUST_COPY.JOIN_CONFIRMATION_BODY}
        </Typography>

        <Typography variant="body2" color="text.secondary" paragraph>
          {TRUST_COPY.JOIN_CONFIRMATION_SETTINGS}
        </Typography>

        <Box sx={{ mt: 3 }}>
          <Typography variant="body2" color="text.secondary">
            <Link
              component={RouterLink}
              to="/transparency"
              sx={{ textDecoration: 'none', color: 'inherit', borderBottom: '1px solid' }}
            >
              {TRUST_COPY.TRANSPARENCY_LINK}
            </Link>
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};
